import {BaseContainerModel} from '../base-container.model';
import {app_mst_link_subject_to_grp_RowClass} from '../../dbschema';
import { bl_fi_cashbook_login_subject_link_RowClass } from '../../dbschema/bl_fi_cashbook_login_subject_link.model';

export class LinkSubjectToCashbookContainerModel extends BaseContainerModel {
  bl_fi_cashbook_login_subject_link: bl_fi_cashbook_login_subject_link_RowClass = new bl_fi_cashbook_login_subject_link_RowClass();
}
